adjustedPrefix